import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    openKeys: [], // 导航展开状态
    selectedKeys: ['/dashboard/globalOverview'], // 导航选中状态
}

export const NavSlice = createSlice({
    name: 'NavSlice',
    initialState,
    // 同步 action/reducers
    reducers: {
        addOpenKeys: (state, action) => {
            state.openKeys = action.payload
        },
        addSelectedKeys: (state, action) => {
            state.selectedKeys = action.payload
        },
    },
    // 异步 action/reducers，注意：reducer 中有 immer 插件，所以不可以使用箭头函数的隐式 return
    extraReducers: {},
})
